<template>
    <table class="el-month-table" @mousedown.prevent>
        <tbody>
            <tr v-for="r in 4" :key="r">
                <td
                    v-for="c in 3"
                    :key="c"
                    :class="getCellClass((r - 1) * 3 + (c - 1))"
                    @click="pickMonth((r - 1) * 3 + (c - 1))"
                >
                    <a class="cell">{{ monthLabel((r - 1) * 3 + (c - 1)) }}</a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  date?: Date;
  modelValue?: Date | null;
}>(), {
    date: () => new Date(),
    modelValue: null,
});

const emit = defineEmits<{
  (e: 'update:modelValue', v: Date | null): void;
  (e: 'pick', v: Date): void;
}>();

const panel = computed(() => props.date ?? new Date());

const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function monthLabel(i: number) {
    return months[i];
}

function getCellClass(i: number) {
    const sel = props.date ? new Date(props.date) : null;
    const isCurrent = sel ? (sel.getFullYear() === panel.value.getFullYear() && sel.getMonth() === i) : false;

    const now = new Date();
    const isTodayYearMonth = now.getFullYear() === panel.value.getFullYear() && now.getMonth() === i;

    return {
        'current': isCurrent,
        'today': isTodayYearMonth,
    };
}

function pickMonth(i: number) {
    const d = new Date(panel.value.getFullYear(), i, 1);
    emit('update:modelValue', d);
    emit('pick', d);
}
</script>
